/**=========================================================
 * Module: fullscreen.js
 * Toggle the fullscreen mode on/off
 =========================================================*/

App.directive('toggleFullscreen', function() {
  'use strict';

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {

      element.on('click', function (e) {
          e.preventDefault();

          if (screenfull.enabled) {
            
            screenfull.toggle();
            
            // Switch icon indicator
            if(screenfull.isFullscreen)
              $(this).children('em').removeClass('aqi-action-expand').addClass('aqi-action-contract');
            else
              $(this).children('em').removeClass('aqi-action-contract').addClass('aqi-action-expand');

          } else {
            $.error('Fullscreen not enabled');
          }

      });
    }
  };

});

